import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { IPagedResponse } from "@aex/ngx-toolbox";
import { BaseApiService } from "./base-service";
import { PremiseApi } from "../api";

import { ClientPremiseImportQueueAdvSearchFilter, IClientPremiseImport, IClientPremiseImportQueue, IClientPremiseImportRequest } from "@aex/shared/common-lib";

@Injectable({
  providedIn: 'root',
})
export class ClientPremiseImportApiService extends BaseApiService {
  constructor(http: HttpClient) {
    super(http);
  }

  public getClientPremiseImportData(request: IClientPremiseImportRequest): Observable<IPagedResponse<IClientPremiseImport>> {
    return this.http.post<IPagedResponse<IClientPremiseImport>>(PremiseApi.clientPremiseImportSearch(), request);
  }

  public getClientPremiseImportQueueData(request: ClientPremiseImportQueueAdvSearchFilter): Observable<IPagedResponse<IClientPremiseImportQueue>> {
    return this.http.post<IPagedResponse<IClientPremiseImportQueue>>(PremiseApi.clientPremiseImportQueueSearch(), request);
  }

}
